import React from 'react';
export const OnboardingPage4: React.FC = () => {
  return <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-dark-900 to-dark-800" data-id="element-567">
      <div className="absolute inset-0 bg-[url('https://transparenttextures.com/patterns/carbon-fibre.png')] opacity-5 pointer-events-none" data-id="element-568" />
      <div className="flex-1 flex flex-col items-center justify-center py-8 px-8 md:px-12" data-id="element-569">
        {/* Logo */}
        <div className="mb-12 w-48 md:w-64" data-id="element-570">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2DzbdAXB8rnWSnnsNSpx4E/widelogo.png" alt="DealFlow.ai Logo" className="w-full h-auto" data-id="element-571" />
        </div>
        {/* Completion Message */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white text-center mb-8 max-w-4xl" data-id="element-572">
          Onboarding Complete! Thank You
        </h1>
        {/* Exit note */}
        <p className="text-sm text-gray-400 italic" data-id="element-573">(you can exit this page)</p>
      </div>
    </div>;
};